module.exports = __webpack_public_path__ + "img/tomates.710cff8a.jpg";